import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as api from '../utils/api';
import useAuthStore from '../stores/useAuthStore';

const PROFILE_KEY = ['profile'];
const STATUS_KEY = ['subscription-status'];

export function useProfile() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return useQuery({
    queryKey: PROFILE_KEY,
    enabled: isAuthenticated,
    queryFn: () => api.fetchProfile(),
  });
}

export function useSubscriptionStatus() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return useQuery({
    queryKey: STATUS_KEY,
    enabled: isAuthenticated,
    queryFn: () => api.fetchSubscriptionStatus(),
  });
}

export function useTrackUsage() {
  return useMutation({
    mutationFn: (metric) => api.trackUsage(metric),
  });
}

export function useRefreshSubscription() {
  const qc = useQueryClient();
  return () => {
    qc.invalidateQueries({ queryKey: PROFILE_KEY });
    qc.invalidateQueries({ queryKey: STATUS_KEY });
  };
}
